import { AuthContext } from '../../context/AuthContext';
import { useEffect, useContext, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

import logo01 from '../../assets/logos/cetificated.png';

import { useLang } from '../../context/LangContext';

import enTexts from '../../translations/en.json';
import esTexts from '../../translations/es.json';

const Welcome = () => {
  const { currentUser } = useContext(AuthContext);
  const { lang } = useLang();
  const [texts, setTexts] = useState(lang === 'es' ? esTexts : enTexts);

  const [universityName, setUniversityName] = useState('');
  const { slug } = useParams();

  useEffect(() => {
    setTexts(lang === 'es' ? esTexts : enTexts);
  }, [lang]);

  const getUniversityName = async () => {
    if (slug === undefined) {
      if (currentUser) {
        setUniversityName(currentUser.isAdmin ? 'Admin' : currentUser.universityName);
      }
      return;
    }

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/${lang}/universities/bySlug/${slug}`
    );

    setUniversityName(texts.welcome);
  };

  useEffect(() => {
    getUniversityName();
  });

  return (
    <div className="text-center bg-sen py-4 d-none">
      <img src={logo01} alt="Logo 1" className="rounded-circle logo" />
      <h2 className="w-100 text-white">{universityName}</h2>
    </div>
  );
};

export default Welcome;
